export type AttendanceStatus = 'PRESENT' | 'ABSENT' | 'EXCUSED' | 'PENDING';
interface GP { studentId: string; studentName: string; studentNickname: string | null; attendance: string }
interface GS { id?: string; startAt: string; status?: string; participants: GP[] }
export interface AttendanceGrid {
  students: { studentId: string; studentName: string; studentNickname: string | null }[];
  dates: string[];
  cell: (studentId: string, date: string) => AttendanceStatus | null;
  /** Session id backing a given (studentId, date) cell, if known — used to link unmarked cells to `/sessions/:id`. */
  sessionIdAt: (studentId: string, date: string) => string | null;
  pendingByStudent: Record<string, number>;
}
const dateKey = (iso: string) => iso.slice(0, 10);

export function pivotAttendanceGrid(sessions: GS[]): AttendanceGrid {
  const live = sessions.filter((s) => s.status !== 'CANCELLED');
  const studentMap = new Map<string, { studentName: string; studentNickname: string | null }>();
  const dateSet = new Set<string>();
  const byCell = new Map<string, AttendanceStatus>(); // key `${studentId}|${date}`
  const sessionByCell = new Map<string, string>(); // key `${studentId}|${date}`
  const pendingByStudent: Record<string, number> = {};
  for (const s of live) {
    const d = dateKey(s.startAt);
    dateSet.add(d);
    for (const p of s.participants) {
      studentMap.set(p.studentId, { studentName: p.studentName, studentNickname: p.studentNickname });
      byCell.set(`${p.studentId}|${d}`, p.attendance as AttendanceStatus);
      if (s.id) sessionByCell.set(`${p.studentId}|${d}`, s.id);
      if (p.attendance === 'PENDING') pendingByStudent[p.studentId] = (pendingByStudent[p.studentId] ?? 0) + 1;
    }
  }
  return {
    students: [...studentMap.entries()].map(([studentId, v]) => ({ studentId, ...v })),
    dates: [...dateSet].sort(),
    cell: (studentId, date) => byCell.get(`${studentId}|${date}`) ?? null,
    sessionIdAt: (studentId, date) => sessionByCell.get(`${studentId}|${date}`) ?? null,
    pendingByStudent,
  };
}
